<template>
  <div>
    <el-container class="home-container">
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="aside-logo-text">
          <router-link to="/">
            <template v-if="isCollapse">
              <img
                class="aside-logo-img"
                src="@/assets/images/logo.png"
                alt="农产品溯源平台"
              />
            </template>
            <template v-else>
              <img
                class="aside-logo-text-img"
                src="@/assets/images/logo-text.png"
                alt="农产品溯源平台"
              />
            </template>
          </router-link>
        </div>
        <el-menu
          :default-active="activePath"
          background-color="#263445"
          text-color="#bfcbd9"
          active-text-color="#409eff"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
        >
          <!-- 一级菜单 -->
          <template v-for="item in menuListApi">
            <el-submenu
              v-if="item.children"
              :index="`${item.id}`"
              :key="`subitem-${item.id}`"
            >
              <template slot="title">
                <i :class="iconlist[item.id]"></i>
                <span>{{ item.meta.title }}</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item
                v-for="subItem in item.children"
                :key="subItem.id"
                :index="`${subItem.path}`"
                @click="saveNavState(`${subItem.path}`)"
              >
                <span style="padding-left:10px;">{{ subItem.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              :index="`${item.path}`"
              :key="`item-${item.id}`"
            >
              <i :class="iconlist[item.id]"></i>
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="navbar">
            <div class="left-menu">
              <span
                class="el-icon-s-fold hamburger icon-hover"
                :class="{'is-active':isActive}"
                @click="toggleCollapse"
              ></span>
              <el-breadcrumb>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item
                  v-for="(item, index) in breadcrumbs"
                  :key="index"
                >{{ item.name }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="right-menu">
              <div style="color:#606266;font-size:14px;padding-bottom:6px"><i class="el-icon-s-home"></i> {{userInfo.orgName}}</div>
              <el-dropdown trigger="hover">
                <div class="avatar-wrapper">
                  <i class="el-icon-user-solid"></i>
                  <i style="padding-left:5px; padding-right:10px;">{{ userInfo.user.loginName }}</i>
                  {{ userInfo.user.userName }}
                  <i class="el-icon-caret-bottom" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button type="text" @click="changePassword">修改密码</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button type="text" @click="logout">退出登录</el-button></el-dropdown-item>
                  <!-- <router-link to="/user/profile">
                    <el-dropdown-item>个人信息</el-dropdown-item>
                  </router-link> -->
                  <!-- <el-dropdown-item divided>
                    <span @click="logout">退出登录</span>
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main>
          <el-card class="box-card">
            <slot />
          </el-card>
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码 -->
    <Dialog custom-class="changePassword" title="修改密码" :visible.sync="changePasswordVisible" width="30%">
      <el-form
        :model="passwordForm"
        :size="$store.state.formSize"
        :rules="passwordFormRules"
        ref="refPasswordForm"
        label-width="140px"
      >
        <el-form-item label="原密码：" prop="oldPassword">
          <el-input
            type="password"
            v-model="passwordForm.oldPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input
            type="password"
            v-model="passwordForm.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="newPassword">
          <el-input
            type="password"
            v-model="passwordForm.newPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="changePasswordVisible = false"
          >取 消</el-button
        >
      </div>
    </Dialog>
  </div>
</template>

<script>
import { getRouters } from '@/api/routers'
import { debounce } from 'throttle-debounce'
import { changePassword } from '@/api/common'
import { getUserInfo } from '@/api/user'
const createForm = () => ({
  oldPassword: '',
  password: '',
  newPassword: ''
})
export default {
  name: 'app',
  data() {
    const newPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      changePasswordVisible: false,
      passwordForm: createForm(),
      // 导航静态数据，等接口调好后对接
      menulist: [
        {
          id: 1,
          authName: '概览',
          path: '/dashboard',
          children: null
        },
        {
          id: 2,
          authName: '系统管理',
          path: null,
          children: [
            {
              id: 201,
              authName: '政府机构',
              path: '/government',
              children: []
            },
            {
              id: 202,
              authName: '企业机构',
              path: '/companies',
              children: []
            },
            {
              id: 203,
              authName: '资源管理',
              path: '/resource',
              children: []
            },
            {
              id: 204,
              authName: '部门管理',
              path: '/department',
              children: []
            },
            {
              id: 205,
              authName: '角色管理',
              path: '/role',
              children: []
            },
            {
              id: 206,
              authName: '用户管理',
              path: '/user',
              children: []
            }
          ]
        },
        {
          id: 3,
          authName: '系统基本配置',
          path: null,
          children: [
            {
              id: 301,
              authName: '供应商管理',
              path: '/supplier',
              children: []
            },
            {
              id: 302,
              authName: '销售商管理',
              path: '/retailer',
              children: []
            },
            {
              id: 303,
              authName: '班次配置管理',
              path: '/classes',
              children: []
            },
            {
              id: 304,
              authName: '人员排班',
              path: '/scheduling',
              children: []
            },
            {
              id: 305,
              authName: '度量单位配置',
              path: '/unitconfig',
              children: []
            }
          ]
        },
        {
          id: 4,
          authName: '产品基本配置',
          path: null,
          children: [
            {
              id: 401,
              authName: '产品溯源项配置',
              path: '/traceConfig',
              children: []
            },
            {
              id: 402,
              authName: '产品管理',
              path: '/productManagement',
              children: []
            }
          ]
        },
        {
          id: 5,
          authName: '批次溯源管理',
          path: null,
          children: [
            {
              id: 501,
              authName: '物料管理',
              path: '/materialManagement',
              children: []
            },
            {
              id: 502,
              authName: '生产记录管理',
              path: '/productLogManagement',
              children: []
            },
            {
              id: 503,
              authName: '批次信息管理',
              path: '/batchManagement',
              children: []
            },
            {
              id: 504,
              authName: '订单管理',
              path: '/orderManagement',
              children: []
            }
          ]
        },
        {
          id: 6,
          authName: '统计分析',
          path: null,
          children: [
            {
              id: 601,
              authName: '溯源详情',
              path: '/traceDetail',
              children: []
            },
            {
              id: 602,
              authName: '统计详情',
              path: '/statisticsDetail',
              children: []
            }
          ]
        },
        {
          id: 7,
          authName: '门户管理',
          path: null,
          children: [
            {
              id: 701,
              authName: '平台特色管理',
              path: '/featureManagement',
              children: []
            },
            {
              id: 702,
              authName: '轮播图管理',
              path: '/slidesManagement',
              children: []
            },
            {
              id: 703,
              authName: '平台简介管理',
              path: '/briefManagement',
              children: []
            },
            {
              id: 704,
              authName: '横幅图管理',
              path: '/bannerManagement',
              children: []
            },
            {
              id: 705,
              authName: '新闻资讯',
              path: '/newsManagement',
              children: []
            },
            {
              id: 706,
              authName: '政策法规',
              path: 'policyManagement',
              children: []
            },
            {
              id: 707,
              authName: '首页配置',
              path: 'indexConfig',
              children: []
            }
          ]
        },
        {
          id: 8,
          authName: '操作日志',
          path: '/operationLog',
          children: null
        }
      ],
      menuListApi: [],
      iconlist: {
        16: 'el-icon-s-home',
        39: 'el-icon-s-home',
        40: 'el-icon-s-home',
        1: 'el-icon-s-tools',
        22: 'el-icon-setting',
        27: 'el-icon-s-shop',
        30: 'el-icon-s-order',
        35: 'el-icon-s-data',
        7: 'el-icon-s-platform',
        8: 'el-icon-s-claim'
      },
      passwordFormRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: newPass, trigger: 'blur' }
        ]
      },
      // 侧边栏显示/隐藏
      isCollapse: false,
      // 侧边栏控制按钮
      isActive: false,
      // 导航激活状态
      activePath: '',
      userInfo: ''
    }
  },
  computed: {
    linkedList() {
      const ROUTERS = []

      ;(function initRouters(routers, parent = null, _routers = ROUTERS) {
        routers.forEach((route, index) => {
          const __ROUTE__ = {
            parent,
            __routers: [],
            ...route
          }

          _routers.push(__ROUTE__)

          if (__ROUTE__.children && __ROUTE__.children.length) {
            initRouters(__ROUTE__.children, __ROUTE__, __ROUTE__.__routers)
          }
        })
      })(this.menuListApi)

      return ROUTERS
    },
    breadcrumbs() {
      const path = this.$route.path
      if (path === '/') {
        return []
      }

      let BREAD

      ;(function getRoute(routers) {
        if (BREAD) return

        for (let i = 0; i < routers.length; i++) {
          const route = routers[i]

          if (route.path === path) {
            BREAD = route
            break
          } else if (route.__routers.length) {
            getRoute(route.__routers)
          }
        }
      })(this.linkedList)

      if (BREAD) {
        const breadcrumbs = []

        ;(function getBreadcrumbs(bread) {
          breadcrumbs.push({
            name: bread.meta.title,
            path: bread.path
          })

          if (bread.parent) {
            getBreadcrumbs(bread.parent)
          }
        })(BREAD)

        return breadcrumbs.reverse()
      }

      return []
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.passwordSubmit)
    this.activePath = window.sessionStorage.getItem('activePath')
    this.$router.push(window.sessionStorage.getItem('activePath'))
    getUserInfo().then(res => {
      if (res.status === 1) {
        this.userInfo = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  mounted() {
    window.addEventListener('resize', this.$_resizeHandler)
    getRouters().then(res => {
      if (res.status === 1) {
        this.menuListApi = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    // 修改密码
    changePassword() {
      this.changePasswordVisible = true
    },
    passwordSubmit() {
      this.$refs.refPasswordForm.validate(valid => {
        if (!valid) return false
        changePassword(this.passwordForm).then(res => {
          if (res.status === 1) {
            this.$message.success('密码修改成功')
            this.changePasswordVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 退出登录
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$message.success('退出成功')
        this.$router.push('/login')
      })
    },
    // 左侧导航伸缩
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
      this.isActive = !this.isActive
    },
    // 判断窗口大小，显示/隐藏侧边栏
    $_resizeHandler() {
      const rect = this.$el.getBoundingClientRect()
      if (rect.width < 992) {
        this.isCollapse = true
        this.isActive = true
      } else {
        this.isCollapse = false
        this.isActive = false
      }
    },
    // 保存导航激活状态
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
    }
  }
}
</script>
<style lang="scss">
.changePassword .el-dialog__header {
  text-align: center;
  padding-bottom: 20px;
}
#app,
.home-container {
  height: 100vh;
  .el-header {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    align-items: center;
    height: 50px;
  }
}
.el-aside {
  background-color: #304156;
  .el-menu {
    border-right: none;
  }
  .aside-logo {
    display: flex;
    align-items: center;
    background-color: #2b2f3a;
    color: #fff;
    width: 200px;
    height: 60px;
    a {
      color: #fff;
      display: flex;
      align-items: center;
    }
    img {
      width: 32px;
      height: 32px;
      margin-left: 20px;
    }
    span {
      margin-left: 15px;
    }
  }
  .aside-logo-text {
    height: 60px;
    line-height: 60px;
    a {
      color: #fff;
    }
    .aside-logo-text-img {
      width: 200px;
      height: 60px;
    }
    .aside-logo-img {
      width: 32px;
      height: 32px;
      margin-top: 16px;
      margin-left: 13px;
    }
  }
}
.el-main {
  background-color: #eff1f4;
  padding:10px !important;
  .el-breadcrumb {
    margin-bottom: 15px;
  }
}
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .left-menu {
    display: flex;
    padding: 0 20px;
    align-items: center;
    .el-breadcrumb {
      margin-left: 15px;
    }
  }
  .hamburger {
    font-size: 24px;
    color: #666;
    cursor: pointer;
    &.is-active {
      transform: rotate(180deg);
    }
  }
}
.right-menu {
  .user-avatar {
    width: 40px;
    height: 40px;
  }
  .el-dropdown {
    cursor: pointer;
  }
}
</style>
